import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    buttonText: {
        color: COLOR.background,
    },
});

export default styles;
